import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/ModifySeats', 'post'>;

type Params = {
  nrOfSeats: number;
};

export const modifySeatsFactory = (apiClient: ApiClient) => {
  const modifySeats = async (variables: Params): Promise<void> => {
    const requestParams = mapInputToRequestParams(variables);
    await apiClient['/api/ModifySeats'].post(requestParams);
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      json: {
        nrOfSeats: input.nrOfSeats,
      },
    };
  };

  return modifySeats;
};
